<template>
    <div>
      <el-card class="box-card" style="margin: 30px; padding: 20px;">
        <div style="display: flex;">
          <div style="width: 420px;">
            <div style="min-height: 800px; border-radius: 10px; border: 1px solid #ccc;">
              <el-carousel height="200px" indicator-position="outside">
                <el-carousel-item v-for="item in branddata" :key="item">
                  <div @click="showlink(item)" style="height:100%; width:100%;">
                    <el-image
                      :src="item.adurl"
                      style="height:100%; width:100%;"
                      fit="cover"></el-image>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div style="margin: 10px; padding: 15px; border: 1px dotted #d9d9d9; border-radius: 6px;">
                <el-row :gutter="20">
                  <el-col :span="6" v-for="item in kjrkdata" :key="item">
                    <div style="display: flex; margin-top: 10px; flex-direction: column; align-items: center; justify-content: center;">
                      <el-image
                        :src="item.scurl"
                        style="width: 64px;height: 64px;display: block;border: 1px dashed #d9d9d9; border-radius: 6px;"
                        fit="cover"></el-image>
                      <div style="margin-top: 10px;">{{item.scname}}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div style="flex: 1;margin: 0 20px 0 40px;">
            <el-row class="querypanel">
              <div style="padding: 0 0 20px 0;">
                <el-button type="primary" icon="el-icon-plus" @click="addtjsp">添加推荐商品</el-button>
              </div>
            </el-row>
            <el-row class="querypanel">
              <el-table
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                stripe
                :data="ztdata"
                ref="multipleTable">
                <el-table-column
                  prop="title"
                  width = "200px"
                  label="标题名称">
                </el-table-column>
                <el-table-column
                  prop="subtitle"
                  label="子标题">
                </el-table-column>
                <el-table-column
                  label="缩略图地址">
                  <template slot-scope="scope">
                    <div>
                      <img :src="scope.row.imgurl" class="avatarimg2">
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑专题" placement="top-start">
                      <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="editzt(scope.$index, ztdata)"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="移除该专题" placement="top-start">
                      <i style="margin-left: 10px;" class="fa fa-trash-o fa-lg curpointer" v-on:click="removezt(scope.$index, ztdata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-dialog title="专题分类" :visible.sync="visztpanel">
              <div class="showpcinfo">
                <el-form  label-width="150px">
                  <el-row class="querypanel">
                    <el-col :span="12">
                      <el-form   label-width="120px"  label-position="left">
                        <el-form-item label="是否放置首页:">
                          <el-select v-model="iffzsyinfo" filterable placeholder="请选择是否放置于首页">
                            <el-option
                              v-for="item in iffzsy"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="12">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="放置序号:">
                          <el-input v-model="fzindex" placeholder="放置序号"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="标题:">
                          <el-input v-model="zttitle" placeholder="请输入标题"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="子标题:" >
                          <el-input v-model="ztsubtitle" placeholder="请输入子标题"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="简介:" >
                          <el-input v-model="ztdes" placeholder="请输入简要描述"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="专题图片:" >
                          <el-upload
                            class="avatar-uploader"
                            drag
                            action=""
                            :on-success="ZTUploadSuccess"
                            :headers="uploadHeaders"
                            :show-file-list="true"
                            :http-request="ZTUploadRequest"
                            :limit="files">
                            <img :src="curfilepath" class="avatar">
                          </el-upload>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="24">
                      <el-form   label-width="120px" label-position="left">
                        <el-form-item label="链接产品分类:" >
                          <el-table
                            :data="goodstypedata"
                            highlight-current-row
                            ref="myztdb1"
                            @current-change="typeselectchange"
                          >
                            <el-table-column
                              prop="name.String"
                              label="分类名称">
                            </el-table-column>
                          </el-table>
                        </el-form-item>
                      </el-form>
                    </el-col>
                  </el-row>
                  <el-row class="querypanel">
                    <el-button @click="addztcontext">添加专题信息</el-button>
                  </el-row>
                </el-form>
              </div>
            </el-dialog>
          </div>
        </div>
      </el-card>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import '../../../static/css/my.css'
  import Utils from '../../util/utils'
  import UpLoadFile from '../upload/UpLoadFile'
  Vue.prototype.$http = axios
  var OSS = require('ali-oss')
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'ZTSet',
    components: {
      UpLoadFile
    },
    data () {
      return {
        branddata: [],
        kjrkdata: [],
        ztdata: [],
        visztpanel: false,
        goodstypedata: [],
        curfilepath: '',
        iffzsyinfo: '1',
        iffzsy: [{
          value: '1',
          label: '放置'
        }, {
          value: '2',
          label: '不放置'
        }],
        fzindex: '',
        ifimg: false,
        curselectdata: '',
        zttitle: '',
        ztsubtitle: '',
        ztdes: '',
        ztparams: '',
        selectpath: '',
        ifnewzt: false,
        selzt: '',
        uploadHeaders: {
          authorization: ''
        },
        files: 100,
        selectuppathtitle: '',
        edittjgoodsdata: '',
        visupfilepanel: false,
        editorOption: {},
        khid: ''
      }
    },
    mounted () {
      that = this
      var v = getCookie('cusid')
      this.khid = v
      that.selectpath = 'ecomm/zt/'
      that.querykjrk()
      that.querybrand()
    },
    methods: {
      querybrand () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querylbi',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.branddata = res.data
              } else {
                that.branddata = []
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      querykjrk () {
        that = this
        if (that.khid === null) {
          that.$message({
            type: 'info',
            message: 'Cookie已失效，请重新登录!'
          })
          that.$router.push({path: '/'})
        } else {
          var qstr = {
            whereinfo: " ownphone ='" + localStorage.getItem('username') + "'",
            limit: '',
            sortinfo: ''
          }
          that.$http({
            url: 'https://ecommapi.sqnetsoft.cn/querykjrk',
            method: 'post',
            data: qstr,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.length > 0) {
                that.kjrkdata = res.data
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      getgtype () {
        var qstr1 = 'cusid = ' + that.khid + ' and parentid >0'
        that.$http({
          url: 'https://api.sqnetsoft.cn/goods/qgt',
          method: 'post',
          data: {
            whereinfo: {String: qstr1, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log('*****************初始化分类数据******************')
            if (res.data.success) {
              console.log('已完成分类数据初始化')
              that.goodstypedata = JSON.parse(res.data.data)
            } else {
              console.log('获取分类数据失败')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addnewzt () {
        this.visztpanel = true
        this.ifnewzt = true
        this.zttitle = ''
        this.ztsubtitle = ''
        this.ztdes = ''
        this.curfilepath = ''
        this.iffzsyinfo = 1
        this.fzindex = 0
      },
      editzt (index, data) {
        var curselectdata = data[index]
        this.selzt = curselectdata
        this.ifnewzt = false
        this.visztpanel = true
        this.ifrecinfo = curselectdata.ifrec
        this.fzindex = curselectdata.recindex
        this.zttitle = curselectdata.title
        this.ztsubtitle = curselectdata.subtitle
        this.ztdes = curselectdata.context
        this.curfilepath = curselectdata.imgurl
        var dataindex = that.goodstypedata.findIndex(d => d.id.Int64 === parseInt(curselectdata.linkurl))
        this.edittjgoodsdata = that.goodstypedata[dataindex]
        setTimeout(() => {
          window.console.log(this.$refs.myztdb1)
          this.$refs.myztdb1.clearSelection()
          this.$refs.myztdb1.setCurrentRow(this.edittjgoodsdata)
        }, 0)
      },
      removezt (index, data) {
        var selectdata = data[index]
        var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
        // 移除该条数据
        data.splice(dataindex, 1)
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/dlcs',
          method: 'post',
          data: {
            whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      addztcontext () {
        console.log(this.iffzsyinfo)
        console.log(this.zttitle)
        console.log(this.ztsubtitle)
        console.log(this.ztdes)
        console.log(this.curfilepath)
        if (this.zttitle === '' || this.ztsubtitle === '' || this.curfilepath === '' || this.selecttype === '') {
          that.$message({
            type: 'info',
            message: '信息填写不完整'
          })
        } else {
          var indextmp = 0
          if (this.fzindex !== '') {
            indextmp = parseInt(this.fzindex)
          }
          var idata
          if (this.ifnewzt) {
            idata = {
              title: this.zttitle,
              subtitle: this.ztsubtitle,
              context: this.ztdes,
              imgurl: this.curfilepath,
              linkurl: this.selecttype.id.Int64.toString(),
              ifrec: parseInt(this.iffzsyinfo),
              recindex: indextmp,
              cusid: parseInt(this.khid)
            }
          } else {
            idata = {
              id: {Int64: parseInt(this.selzt.id.Int64), Valid: true},
              title: this.zttitle,
              subtitle: this.ztsubtitle,
              context: this.ztdes,
              imgurl: this.curfilepath,
              linkurl: this.selecttype.id.Int64.toString(),
              ifrec: parseInt(this.iffzsyinfo),
              recindex: indextmp,
              cusid: parseInt(this.khid)
            }
          }

          that.$http({
            url: 'https://api.sqnetsoft.cn/layout/aaulcs',
            method: 'post',
            data: idata,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                that.$message({
                  type: 'success',
                  message: '添加完毕'
                })
                that.$options.methods.queryzt()
                that.visztpanel = false
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      },
      queryzt () {
        var qstr = 'cusid = ' + that.khid
        that.$http({
          url: 'https://api.sqnetsoft.cn/layout/glcs',
          method: 'post',
          data: {
            whereinfo: {String: qstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              var objtmp = JSON.parse(res.data.data)
              console.log(objtmp)
              that.ztdata = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      typeselectchange (row) {
        console.log(row)
        this.selecttype = row
        this.select_type = row.name.String
      },
      createOssClient () {
        return new Promise((resolve, reject) => {
          let client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: 'LTAIK44bzZpLz0As',
            accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
            bucket: 'sqpro'
          })
          resolve(client)
        })
      },
      async ZTUploadRequest (option) {
        var that = this
        let file = option.file
        const self = this
        return new Promise((resolve, reject) => {
          let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
          console.log(date)
          let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
          let randomStr = self.randomString(4)//  4位随机字符串
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          console.log(dateTime)
          console.log(randomStr)
          console.log(extensionName)
          let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.createOssClient().then(client => {
            // 异步上传,返回数据
            resolve({
              fileName: file.name,
              fileUrl: fileName
            })
            // 上传处理
            // 分片上传文件
            client.multipartUpload(fileName, file, {
              progress: function (p) {
                let e = {}
                e.percent = Math.floor(p * 100)
                // console.log('Progress: ' + p)
                option.onProgress(e)
                that.uppercent = e.percent
                console.log(e.percent)
              }
            }).then((val) => {
              if (val.res.statusCode === 200) {
                option.onSuccess(val)
                return val
              } else {
                option.onError('上传失败')
              }
            }, err => {
              option.onError('上传失败')
              reject(err)
            })
          }).catch(errinfo => {
          })
        })
      },
      async ZTUploadSuccess (res, file, fileList) {
        console.log(res)
        if (res.res.status === 200) {
          that.curfilepath = 'https://' + res.bucket + '.oss-cn-beijing.aliyuncs.com/' + res.name
        }
        // TODO
      },
      randomString (num) {
        let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
        let res = ''
        for (let i = 0; i < num; i++) {
          var id = Math.ceil(Math.random() * 35)
          res += chars[id]
        }
        return res
      }
    }
  }
  function getCookie (name) {
    var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/control/ZTSet.vue